import { useContext } from 'react';
import { ContentHeaderContext } from './context';

export const useContentHeader = () => {
  const context = useContext(ContentHeaderContext);
  if (!context) {
    throw new Error(
      'useContentHeader must be used within ContentHeaderProvider'
    );
  }
  return context;
};
